// Legacy Zapiet initializes delivery eligibility on a full cart-page load, but
// does not refresh it when Dawn removes the final physical line through AJAX.
// Preserve native cart updates except when that confirmed eligibility changes.
class BDCartFulfillmentSync extends HTMLElement {
  connectedCallback() {
    if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    this.requiresShipping = this.dataset.requiresShipping === 'true' ? true
      : this.dataset.requiresShipping === 'false' ? false : undefined;
    this.reloading = false;
    this.sequence = 0;
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => this.onCartUpdate(event));
  }

  state(cart) {
    if (!cart || cart.errors || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count)
      || cart.item_count < 0 || typeof cart.requires_shipping !== 'boolean') return undefined;
    return cart.requires_shipping;
  }

  async onCartUpdate(event) {
    if (!this.isConnected || this.reloading || event?.cartData?.errors) return;
    const sequence = ++this.sequence;
    this.controller?.abort();
    let next = this.state(event?.cartData);
    if (next === undefined) {
      // Add-to-cart events can contain only the added item, not cart totals.
      // Never infer the complete cart's eligibility from that partial payload.
      const controller = this.controller = new AbortController();
      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: {Accept: 'application/json'},
        });
        if (!response.ok) return;
        next = this.state(await response.json());
      } catch { return; }
    }
    if (!this.isConnected || this.reloading || sequence !== this.sequence || next === undefined) return;
    if (typeof this.requiresShipping === 'boolean' && this.requiresShipping !== next) {
      this.reloading = true;
      // Preserve the current preview/country URL and let Shopify + Zapiet
      // recalculate their real state. Do not hide controls or edit app fields.
      window.location.reload();
    } else {
      this.requiresShipping = next;
    }
  }

  disconnectedCallback() {
    this.sequence++;
    this.controller?.abort();
    this.unsubscribe?.();
    this.unsubscribe = null;
  }
}

if (!customElements.get('bd-cart-fulfillment-sync')) {
  customElements.define('bd-cart-fulfillment-sync', BDCartFulfillmentSync);
}
